export const classGroupData = {
    drafrList : [
        {name:'课程ID',text: 'courseId'},
        {name:'课程名称',text: 'courseName'},
        {name:'小组名称',text: 'groupName'},
        {name:'基金经理',text: 'name'},
    ],
    currentPage:1,
    pageSize: 10,
    total: 0,
    loading: true,
    operation: ['查看','删除'],//,'成员权限'，'修改余额'
    spreadTable:[],
    tableHeight: 400,
    pageType: 1,
    lastState: 1000,

    userInput: undefined,

    showRoleDia: false,
    userItem:{},
    userValue:'',
    userOptions:[],
    setMoney: 0
}